import styled from 'styled-components'

const Text = styled.h2`
  width: 80%;
  @media (max-width: 768px) {
    width: 90%;
  }
  @media (max-width: 480px) {
    width: 95%;
  }
`

export default function Header({ children }) {
  return (
    <Text>
      {children}
    </Text>
  )
}
